import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "nm_cookie_consent_v1";

export default function CookieBanner() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const v = localStorage.getItem(KEY);
        if (!v) {
            const t = setTimeout(() => setOpen(true), 700);
            return () => clearTimeout(t);
        }
    }, []);

    const choose = (value) => {
        localStorage.setItem(KEY, value);
        setOpen(false);
    };

    if (!open) return null;

    return (
        <div
            className="fixed inset-x-3 bottom-3 md:inset-x-auto md:right-6 md:bottom-6 md:max-w-md z-[80]"
            role="dialog"
            aria-live="polite"
            data-testid="cookie-banner"
        >
            <div className="bg-black/95 backdrop-blur-xl border border-white/15 p-6 md:p-7 text-white shadow-2xl">
                <div className="kicker mb-2">Cookie & Privacy</div>
                <p className="text-sm text-white/80 leading-relaxed mb-5">
                    Utilizziamo cookie tecnici necessari per il funzionamento del sito. Con il tuo
                    consenso possiamo utilizzare anche cookie analitici per migliorare il servizio.
                    Consulta la{" "}
                    <Link to="/privacy" className="underline underline-offset-4 hover:text-[color:var(--brand-accent)]">
                        Privacy Policy
                    </Link>{" "}
                    e la{" "}
                    <Link to="/cookies" className="underline underline-offset-4 hover:text-[color:var(--brand-accent)]">
                        Cookie Policy
                    </Link>
                    .
                </p>
                <div className="flex flex-wrap gap-2">
                    <button
                        type="button"
                        onClick={() => choose("accepted")}
                        className="btn-primary px-5 py-2.5 text-xs"
                        data-testid="cookie-accept"
                    >
                        Accetta tutti
                    </button>
                    <button
                        type="button"
                        onClick={() => choose("essential")}
                        className="btn-ghost text-white px-5 py-2.5 text-xs"
                        data-testid="cookie-essential"
                    >
                        Solo essenziali
                    </button>
                </div>
            </div>
        </div>
    );
}
